// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","authButton":"_2WRQXNJkZ_J1faAd_w5grr"};